/**
 * Sélecteurs pour la gestion de l'utilisateur connecté
 * @category Store
 * @hideconstructor
 */
var ConnectedUserStoreSelector = /*#__PURE__*/function () {
  function ConnectedUserStoreSelector() {}

  /**
   * Sélection de l'object contenant les informations de l'utilisateur connecté
   * @param {object} state state de l'application
   * @returns {object} Object contenant les informations de l'utilisateur connecté
   */
  ConnectedUserStoreSelector.selectConnectedUser = function selectConnectedUser(state) {
    return state.manageConnectedUser.user;
  };

  return ConnectedUserStoreSelector;
}(); // Exports


export var selectConnectedUser = ConnectedUserStoreSelector.selectConnectedUser;